import React from "react";
import banner from "../../../assets/images/chi/banner2.jpg";

const Prevent = () => {
  return (
   <div>
     <div className="flex flex-col gap-4 mt-10 pb-14">
      <div className="text-center titlefont flex flex-col gap-3">
        <h1 className="text-xl font-semibold">Chi Wellness Store</h1>
      </div>
      <div className=" flex justify-center">
        <img
          src={banner}
          className="w-5/6 object-cover h-auto lg:h-96"
          alt=""
        />
      </div>
    </div>
    <h1 className="text-center text-2xl titlefont font-semibold pb-10">Shop By Categories</h1>
   </div>
  );
};

export default Prevent;
